const COLUMN_DATA_FIELD_MAP: Readonly<Record<string, string>> = {
  benchmark: 'benchmarkId',
  country: 'countryId',
  couponType: 'couponTypeId',
  currency: 'currencyId',
  debut: 'debutId',
  product: 'productId',
  registration: 'registrationId',
  segment: 'marketSegmentId',
  sizeDescription: 'sizeDescriptionId',
  uop: 'uopId',
};

export default COLUMN_DATA_FIELD_MAP;
